module.exports = __webpack_public_path__ + "img/mt4-icon9.2ce6127.png";